import React, { forwardRef } from 'react';

import MUIChip, { ChipProps as MUIChipProps } from '@material-ui/core/Chip';

interface ChipProps extends MUIChipProps {}

const Chip = forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  return <MUIChip {...props} ref={ref} />;
});

Chip.displayName = 'Chip';

export default Chip;
